import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { ScrollToTop } from './components/shared/ScrollToTop';
import { CookieProvider } from './contexts/CookieContext';
import { CookieBanner } from './components/shared/CookieBanner';
import { CookieSettings } from './components/shared/CookieSettings';

// 页面组件
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import AccessoriesParts from './pages/AccessoriesParts';
import About from './pages/About';
import Support from './pages/Support';
import Technology from './pages/Technology';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import CookiePolicy from './pages/CookiePolicy';
import LegalTerms from './pages/LegalTerms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ServiceNetwork from './pages/ServiceNetwork';
import WarrantyConditions from './pages/WarrantyConditions';
import NotFound from './pages/NotFound';
import ElectricBikes from './pages/ElectricBikes';
import Matriculas from './pages/Matriculas';
import Seguros from './pages/Seguros';
import { getProductById, getProductByRoute } from './data/productsLoader';

const WARRANTY_EXTENSION_REDIRECT_URL = 'https://zwheel-shop.com/registra-tu-patinete/';
const CIRCULATION_CERTIFICATE_REDIRECT_URL = 'https://zwheel-shop.com/solicita-certificado-circulacion/';

function LegacyProductRedirect() {
  const { id, lineId, productId } = useParams<{ id?: string; lineId?: string; productId?: string }>();
  const product = lineId && productId
    ? getProductByRoute(lineId, productId)
    : id
    ? getProductById(id)
    : undefined;

  return <Navigate to={product?.link || '/patinetes-electricos'} replace />;
}

function ExternalRedirect({ to }: { to: string }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

function App() {
  return (
    <CookieProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-white">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/patinetes-electricos" element={<Products />} />
              <Route path="/patinetes-electricos/:lineId/:productId" element={<ProductDetail />} />
              <Route path="/bicicletas-electricas" element={<ElectricBikes />} />
              <Route path="/accesorios-recambios" element={<AccessoriesParts />} />
              <Route path="/soporte" element={<Support />} />
              <Route path="/soporte/red-servicio-tecnico" element={<ServiceNetwork />} />
              <Route path="/sobre-zwheel" element={<About />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/matricula" element={<Matriculas />} />
              <Route path="/matriculas" element={<Navigate to="/matricula" replace />} />
              <Route path="/seguros" element={<Seguros />} />

              <Route path="/products" element={<Navigate to="/patinetes-electricos" replace />} />
              <Route path="/products/:id" element={<LegacyProductRedirect />} />
              <Route path="/products/:lineId/:productId" element={<LegacyProductRedirect />} />
              <Route path="/about" element={<About />} />
              <Route path="/technology" element={<Technology />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/cookies" element={<CookiePolicy />} />
              <Route path="/legal/privacy" element={<PrivacyPolicy />} />
              <Route path="/legal/terms" element={<LegalTerms />} />
              <Route path="/legal/condiciones-garantia" element={<WarrantyConditions />} />
              <Route path="/extension-de-garantia-5-anos" element={<ExternalRedirect to={WARRANTY_EXTENSION_REDIRECT_URL} />} />
              <Route path="/solicita-certificado-circulacion" element={<ExternalRedirect to={CIRCULATION_CERTIFICATE_REDIRECT_URL} />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
          <CookieSettings />
        </div>
      </Router>
    </CookieProvider>
  );
}

export default App;
